import { render, staticRenderFns } from "./EditBookingCompliance.vue?vue&type=template&id=3a6b037c&"
import script from "./EditBookingCompliance.vue?vue&type=script&lang=js&"
export * from "./EditBookingCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports